
// Keep the landing-page quantity offer stable while Loop updates its unit price.
function landingBuyboxQuantityPrice(fallback) {
  const box = document.querySelector('#order.lp-product-buybox .quantity-box.active');
  if (!box) return fallback;
  const price = box.getAttribute('data-price');
  const placement = document.querySelector('#order.lp-product-buybox afterpay-placement');
  if (price && placement) placement.setAttribute('data-amount', price.replace(/[^0-9.]/g, ''));
  const compare = box.querySelector('.old-price')?.textContent.trim();
  return price ? price + (compare ? '<span class="compare-at">' + compare + '</span>' : '') : fallback;
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
//   summary.setAttribute('role', 'button');
//   summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

//   if (summary.nextElementSibling.getAttribute('id')) {
//     summary.setAttribute('aria-controls', summary.nextElementSibling.id);
//   }

//   summary.addEventListener('click', (event) => {
//     event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
//   });

//   if (summary.closest('header-drawer, menu-drawer')) return;
//   summary.parentElement.addEventListener('keyup', onKeyUpEscape);
// });

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Add hover functionality for mega menu items only
document.addEventListener('DOMContentLoaded', function () {
  const megaMenuItems = document.querySelectorAll('.header__inline-menu details.mega-menu');
  megaMenuItems.forEach(item => {
    const summary = item.querySelector('summary');

    // Open on hover over summary
    summary.addEventListener('mouseenter', () => {
      item.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    // Keep open when hovering over content
    const content = item.querySelector('.mega-menu__content');
    if (content) {
      content.addEventListener('mouseenter', () => {
        item.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      content.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!item.matches(':hover') && !content.matches(':hover')) {
            item.removeAttribute('open');
            summary.setAttribute('aria-expanded', 'false');
          }
        }, 100); // Small delay to prevent instant closing
      });
    }

    // Close when leaving the menu item
    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!item.matches(':hover') && !content.matches(':hover')) {
          item.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }
      }, 100);
    });
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelector('.shopify-section-header-sticky').style.transform = 'none';

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();


      var variantQtyWrap = document.querySelector('.qty-breaks-block .quantity-section');
      if (variantQtyWrap) {
        document.querySelectorAll('.quantity-box').forEach(box => {
          box.addEventListener('click', () => {
            // Remove active class from all quantity boxes
            document.querySelectorAll('.quantity-box').forEach(b => b.classList.remove('active'));
            // Add active class to clicked box
            box.classList.add('active');
            // Update quantity input value
            const value = box.getAttribute('data-value');
            document.querySelector('product-info .quantity__input').value = value;
          });
        });

        // Trigger click on the first box by default
        const selectedLandingQuantity = this.closest('#order.lp-product-buybox')?.querySelector('.quantity-box.active');
        (selectedLandingQuantity || document.querySelector('.quantity-box[data-value="1"]'))?.click();
      }

    }

    this.updateWidget();
  }

  updateWidget() {

    var labels = document.querySelectorAll('variant-radios label');
    var frequencies = document.querySelectorAll('.rc_select__frequency .shipping_frequency');
    var atcButton = document.querySelector('.product-form__submit');
    var frequencyInterval = document.querySelector('.shipping_frequency');
    // var typeLabels = document.querySelectorAll('.rc-button-group__options .rc-radio');

    function waitForStay(selector, callback) {
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (element) {
          callback(element);
          observer.disconnect();
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true,
      });
    }

    waitForStay('.loop-widget-purchase-options-container', (element) => {
      var typeLabels = document.querySelectorAll('.loop-widget-container .loop-widget-purchase-option');
      // var activeSubscription = document.querySelector('.rc-radio--active.subscription-radio');
      // var oneTimeLabel = document.querySelector('.rc-radio.onetime-radio .discount-label');
      // var subscriptionLabel = document.querySelector('.rc-radio.subscription-radio .discount-label');

      // oneTimeLabel.innerHTML = '<span>One Time Purchase</span>';
      // subscriptionLabel.innerHTML = '<span>Membership Savings</span>';

      // if (activeSubscription) {
      //   var membershipPriceLoad = document.querySelector('.product-form__submit .price.membership');
      //   var oneTimePriceContentLoad = document.querySelector('.onetime-radio .price-label').textContent;
      //   oneTimePriceContentLoad = oneTimePriceContentLoad.replace(/EUR|GBP|USD|AED/g, '');
      var oneTimePriceContentLoad = document.querySelector('div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price').textContent;
      //   var membershipPriceContentLoad = document.querySelector('.subscription-radio .price-label').textContent;
      //   membershipPriceContentLoad = membershipPriceContentLoad.replace(/EUR|GBP|USD|AED/g, '');
      //   var onetimePriceLoad = document.querySelector('.product-form__submit .price.regular');
      //   var membershipLowPriceLoad = document.querySelector('.product-form__buttons .ALAmembership');
      //   var onetimeLowPriceLoad = document.querySelector('.product-form__buttons .ALAonetime');
      //   var membershipBannerLoad = document.querySelector('.AsLowAs-Image .ALAmembership');
      //   var onetimeBannerLoad = document.querySelector('.AsLowAs-Image .ALAonetime');
      //   var afterpayBlockLoad = document.querySelector('afterpay-placement');

      //   onetimePriceLoad.style.display = 'none';
      //   membershipPriceLoad.innerHTML = membershipPriceContentLoad + `<span class="compare-at">` + oneTimePriceContentLoad + `</span>`;
      //   membershipPriceLoad.style.display = 'flex';
      //   membershipLowPriceLoad.style.display = 'inline-block';
      //   onetimeLowPriceLoad.style.display = 'none';
      //   membershipBannerLoad.style.display = 'block';
      //   onetimeBannerLoad.style.display = 'none';

      //   if (afterpayBlockLoad) {
      //     afterpayBlockLoad.style.display = 'none';
      //   }
      // }

      //console.log(oneTimePriceContentLoad,'oneTimePriceContentLoad 111');
      document.querySelector('.product-form__submit .price.regular').innerHTML = landingBuyboxQuantityPrice(oneTimePriceContentLoad);

      typeLabels.forEach((label) => {
        label.addEventListener('click', (e) => {
          //console.log(e,'clicked');
          var activeType = document.querySelector('.loop-widget-purchase-option.loop-widget-purchase-option-selected');
          var oneTimeOption = document.querySelector('div[data-loop-widget-onetime-purchase-option]');
          var membershipOption = document.querySelector('div[data-loop-widget-selling-plan-group]');
          var membershipLowPrice = document.querySelector('.product-form__buttons .ALAmembership');
          var onetimeLowPrice = document.querySelector('.product-form__buttons .ALAonetime');
          var membershipBanner = document.querySelector('.AsLowAs-Image .ALAmembership');
          var onetimeBanner = document.querySelector('.AsLowAs-Image .ALAonetime');
          var membershipPrice = document.querySelector('.product-form__submit .price.membership');
          var oneTimePriceContent = document.querySelector('div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price').textContent;
          //console.log(oneTimePriceContent,'oneTimePriceContent');
          // oneTimePriceContent = oneTimePriceContent.replace(/EUR|GBP|USD|AED/g, '');
          var membershipPriceContent = document.querySelector('div[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price').textContent;
          //console.log(membershipPriceContent,'membershipPriceContent');
          // membershipPriceContent = membershipPriceContent.replace(/EUR|GBP|USD|AED/g, '');
          var onetimePrice = document.querySelector('.product-form__submit .price.regular');
          var afterpayBlock = document.querySelector('afterpay-placement');
          //var cancelTooltip = document.querySelector('.tooltip-container .tooltip-cancel');
          var variantQtyWrapDyn = document.querySelector('.qty-breaks-block .quantity-section');
          if (variantQtyWrapDyn) {
            var boxes = document.querySelectorAll('.quantity-box');
            var input = document.querySelector('product-info .quantity__input');
          }

          if (activeType) {
            activeType.classList.remove('active');
          }

          label.classList.add('active');

          if (variantQtyWrapDyn) {

            if (!boxes.length || !input) {
              console.error('No .quantity-box elements or .quantity__input found in the DOM');
              return;
            }

            //console.log('input', input);

            boxes.forEach((box) => {
              box.addEventListener('click', () => {
                boxes.forEach((b) => b.classList.remove('active'));
                box.classList.add('active');
                var value = box.getAttribute('data-value');
                input.value = value;

                var boxPrice = box.getAttribute('data-price');
                if (this.closest?.('#order.lp-product-buybox')) document.querySelector('.price.regular').innerHTML = landingBuyboxQuantityPrice(boxPrice);
                else document.querySelector('.price.regular').textContent = boxPrice;

                // console.log('click', value);
              });
            });
          }

          if (label.getAttribute('data-loop-widget-selling-plan-group') !== null) {

            membershipPrice.innerHTML = membershipPriceContent + `<span class="compare-at">` + oneTimePriceContent + `</span>`;
            membershipPrice.style.display = 'flex';
            if (membershipLowPrice) {
              membershipLowPrice.style.display = 'inline-block';
            }
            if (membershipBanner) {
              membershipBanner.style.display = 'block';
            }
            onetimePrice.style.display = 'none';
            if (onetimeLowPrice) {
              onetimeLowPrice.style.display = 'none';
            }
            if (onetimeBanner) {
              onetimeBanner.style.display = 'none';
            }

            atcButton.classList.add('membership-active');

            if (afterpayBlock) {
              afterpayBlock.style.display = 'none';
            }

            if (variantQtyWrapDyn) {
              boxes[0].click();
              variantQtyWrapDyn.style.display = 'none';
            }

          } else if (label.getAttribute('data-loop-widget-onetime-purchase-option') !== null) {

            document.querySelector('.product-form__submit .price.regular').innerHTML = landingBuyboxQuantityPrice(oneTimePriceContentLoad);

            membershipPrice.style.display = 'none';
            if (membershipLowPrice) {
              membershipLowPrice.style.display = 'none';
            }
            if (membershipBanner) {
              membershipBanner.style.display = 'none';
            }
            onetimePrice.style.display = 'inline-block';
            if (onetimeLowPrice) {
              onetimeLowPrice.style.display = 'inline-block';
            }
            if (onetimeBanner) {
              onetimeBanner.style.display = 'block';
            }

            atcButton.classList.remove('membership-active');

            document.querySelectorAll('.rc_select__frequency .input-field input').forEach((frequencyInput) => {
              frequencyInput.setAttribute('name', '');
            });

            if (afterpayBlock) {
              afterpayBlock.style.display = 'block';
            }

            if (variantQtyWrapDyn) {
              boxes[0].click();
              variantQtyWrapDyn.style.display = 'block';
            }
          }
        });
      });

      // Add a MutationObserver to observe changes to the widget container
      const widgetContainerObserver = new MutationObserver(() => {
        // Re-run the code when the widget container is modified
        typeLabels = document.querySelectorAll('.loop-widget-container .loop-widget-purchase-option');
        //console.log(typeLabels, 'typeLabels');
        // ... (rest of the code remains the same)
      });

      widgetContainerObserver.observe(element, {
        childList: true,
        subtree: true,
      });

    });

    labels.forEach((label) => {
      label.addEventListener('click', function () {
        var subsVariantId = this.getAttribute('data-subs-var-id');
        var variantName = this.getAttribute('data-variant-name');
        var upgradeId = this.getAttribute('data-upgrade');
        var sliderVariants = document.querySelectorAll('#thumbs .thumb');
        var btnUpgrade = document.querySelector('.btn-upgrade');

        // Remove 'active' class from all labels
        labels.forEach((previousLabel) => {
          previousLabel.classList.remove('active');
        });

        sliderVariants.forEach((sliderVariant) => {
          var sliderVariantValue = sliderVariant.getAttribute('data-variant-value');

          if (sliderVariantValue === variantName) {
            flkty.select(sliderVariant.getAttribute('data-index') - 1);
            var slideSrc = sliderVariant.querySelector('img').src;
            document.getElementById('main-image').src = slideSrc;
          }
        });

        // Add 'active' class to the clicked label
        this.classList.add('active');

        if (btnUpgrade) {
          btnUpgrade.setAttribute('data-upgrade-id', upgradeId);
        }

        atcButton.setAttribute('data-subs-id', subsVariantId);

        var atcPrice = document.querySelector('div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price').textContent;
        //console.log(atcPrice,'atcPrice2222');
        document.querySelector('.product-form__submit .price.regular').innerHTML = landingBuyboxQuantityPrice(atcPrice);

      });
    });

    frequencies.forEach((frequency) => {
      frequency.addEventListener('click', function () {
        // Update the value of frequencyInterval
        frequencyInterval = this.getAttribute('data-interval');
        var inputId = frequency.getAttribute('for');

        if (inputId) {
          // Find the associated input element using the input ID
          var input = document.getElementById(inputId);

          if (input) {

            document.querySelectorAll('.rc_select__frequency .input-field input').forEach((frequencyInput) => {
              //frequencyInput.setAttribute('name', 'properties[_shipping_interval_frequency]');
              frequencyInput.setAttribute('name', '');
              frequencyInput.checked = false;
            });

            // Set the 'name' attribute on the input element
            input.setAttribute('name', 'properties[shipping_interval_frequency]');
            input.checked = false;

          }
        }
      });
    });

    var upgradeBtn = document.querySelector('.btn-upgrade');
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      //const input = productForm.querySelector('input[name="id"]');
      const input = productForm.querySelector('.product-variant-id');

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      this.dataset.landingBuybox === 'true'
        ? `${this.dataset.url}?variant=${requestedVariantId}`
        : `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        let html = new DOMParser().parseFromString(responseText, 'text/html');
        if (this.dataset.landingBuybox === 'true') {
          const sourceSection = html.querySelector('product-info')?.dataset.section;
          if (!sourceSection) throw new Error('Product section missing from variant response');
          const sourceInfo = html.querySelector('product-info');
          for (const element of [sourceInfo, ...sourceInfo.querySelectorAll('*')]) {
            for (const attribute of ['id', 'for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'data-section']) {
              const value = element.getAttribute(attribute);
              if (value && value.includes(sourceSection)) element.setAttribute(attribute, value.split(sourceSection).join(this.dataset.section));
            }
          }
        }
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;



    if (disable) {
      addButton.setAttribute('disabled', 'disabled');

      if (!document.querySelector(".template-product-pdp-touch")) {
        if (text) addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      //addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


document.addEventListener('DOMContentLoaded', function () {
  // Get all elements with class "icon-close" for desktop and mobile
  var closeButtonsDesktop = document.querySelectorAll('.header-drawer__desktop .menu-drawer__navigation-container .icon-close');
  var closeButtonsMobile = document.querySelectorAll('.header-drawer__mobile .menu-drawer__navigation-container .icon-close');

  // Get the element with class "header__icon.header__icon--menu" for desktop and mobile
  var menuIconDesktop = document.querySelector('.header-drawer__desktop .header__icon.header__icon--menu');
  var menuIconMobile = document.querySelector('.header-drawer__mobile .header__icon.header__icon--menu');

  // Attach a click event listener to each "icon-close" element for desktop
  closeButtonsDesktop.forEach(function (closeButton) {
    closeButton.addEventListener('click', function () {
      // Trigger a click event on the "menuIcon" element
      menuIconDesktop.click();
    });
  });

  // Attach a click event listener to each "icon-close" element for mobile
  closeButtonsMobile.forEach(function (closeButton) {
    closeButton.addEventListener('click', function () {
      // Trigger a click event on the "menuIcon" element
      menuIconMobile.click();
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var dropdownItemsDesktop = document.querySelectorAll('.header-drawer__desktop .has__dropdown');
  var dropdownListDesktop = document.querySelector('.header-drawer__desktop .dropdown__list');
  var dropdownItemsMobile = document.querySelectorAll('.header-drawer__mobile .has__dropdown');
  var dropdownListMobile = document.querySelector('.header-drawer__mobile .dropdown__list');

  dropdownItemsDesktop.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();

      if (dropdownListDesktop.classList.contains('active')) {
        dropdownListDesktop.classList.remove('active');
        item.classList.remove('active');
      } else {
        dropdownListDesktop.classList.add('active');
        item.classList.add('active');
      }
    });
  });

  dropdownItemsMobile.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();

      if (dropdownListMobile.classList.contains('active')) {
        dropdownListMobile.classList.remove('active');
        item.classList.remove('active');
      } else {
        dropdownListMobile.classList.add('active');
        item.classList.add('active');
      }
    });
  });
});

function setupTooltips() {
  var tooltipIcons = document.querySelectorAll(".tooltip-icon");
  var tooltip = document.getElementById("tooltip");
  var tooltipContent = tooltip.querySelector(".tooltip-content");
  var closeBtn = tooltip.querySelector(".close");

  tooltipIcons.forEach(function (icon) {
    icon.addEventListener("click", function (event) {
      var tooltipInfo = event.currentTarget.querySelector('.tooltip-info').innerHTML;
      tooltip.querySelector('.tooltip-content').innerHTML = tooltipInfo;
      tooltip.style.display = "block";
      event.stopPropagation();

      // Close other tooltips
      tooltipIcons.forEach(function (otherIcon) {
        if (otherIcon !== icon) {
          otherIcon.classList.remove("active");
        }
      });
      icon.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", function (event) {
    event.stopPropagation();
    tooltip.style.display = "none";
    tooltipIcons.forEach(function (icon) {
      icon.classList.remove("active");
    });
  });

  document.addEventListener("click", function (event) {
    if (!tooltip.contains(event.target)) {
      tooltip.style.display = "none";
      tooltipIcons.forEach(function (icon) {
        icon.classList.remove("active");
      });
    }
  });
}

if (document.querySelector(".template-product") && !document.querySelector(".template-product-pdp-landing") && !document.querySelector(".template-product-pdp-touch")) {
  setupTooltips();
}

function setupQuestionTooltips() {
  const questionIcons = document.querySelectorAll(".question-icon");

  questionIcons.forEach(icon => {
    const tooltipInfo = icon.querySelector('.question-tooltip-info');
    const questionTooltip = icon.nextElementSibling;
    const questionCloseBtn = questionTooltip.querySelector(".close");
    const tooltipContent = questionTooltip.querySelector('.question-tooltip-content');

    icon.addEventListener("click", event => {
      event.stopPropagation();

      if (tooltipInfo) {
        tooltipContent.innerHTML = tooltipInfo.innerHTML;
      }

      closeAllTooltips(questionIcons);
      icon.classList.add("active");
      questionTooltip.style.display = "block";
    });

    questionCloseBtn.addEventListener("click", event => {
      event.stopPropagation();
      icon.classList.remove("active");
      questionTooltip.style.display = "none";
    });
  });

  document.addEventListener("click", event => {
    closeAllTooltips(questionIcons);
  });

  function closeAllTooltips(icons) {
    icons.forEach(icon => {
      icon.classList.remove("active");
      const tooltip = icon.nextElementSibling;
      tooltip.style.display = "none";
    });
  }
}

if (document.querySelector(".template-product")) {
  setupQuestionTooltips();
}

if (document.querySelector(".template-product-subscriptionForTesting")
  || document.querySelector(".template-product-partial-coverage")
  || document.querySelector(".template-product-womens-colorbox")
  || document.querySelector(".template-product-pdp-landing")) {
  var elem = document.querySelector('.thumbs');

  // Debounce function to limit resize calls
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  if (document.querySelector(".template-product-pdp-landing")) {
    var flkty = new Flickity(elem, {
      // options
      cellAlign: 'center',
      contain: true,
      draggable: true,
      pageDots: true,
      prevNextButtons: false,
      imagesLoaded: true
    });

    // Resize after images are loaded
    if (elem) {
      elem.addEventListener('ready.flickity', function () {
        flkty.resize();
      });
    }

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      flkty.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      flkty.resize();
    }, 250));
  } else if (document.querySelector(".color-box-imagetest")) {

    var elements = document.querySelectorAll('.thumbs');

    elements.forEach(function (elem) {
      var flkty = new Flickity(elem, {
        // options
        cellAlign: 'center',
        contain: true,
        draggable: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true
      });

      // Resize after images are loaded
      elem.addEventListener('ready.flickity', function () {
        flkty.resize();
      });

      // Additional resize with delay to ensure proper initial display
      setTimeout(function () {
        flkty.resize();
      }, 100);

      // Resize on window resize with debounce
      window.addEventListener('resize', debounce(function () {
        flkty.resize();
      }, 500));
    });

    // Thumbnail Sliders
    var thumbnailSliders1 = document.querySelector('#thumbs-thumbnails-1');
    var thumbnailSliders2 = document.querySelector('#thumbs-thumbnails-2');
    var thumbnailSliders3 = document.querySelector('#thumbs-thumbnails-3');
    var thumbnailSliders4 = document.querySelector('#thumbs-thumbnails-4');
    var thumbnailSliders5 = document.querySelector('#thumbs-thumbnails-5');
    var thumbnailSliders6 = document.querySelector('#thumbs-thumbnails-6');
    var thumbnailSliders7 = document.querySelector('#thumbs-thumbnails-7');

    var tSliders1 = new Flickity(thumbnailSliders1, {
      asNavFor: ".thumbs-1",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders1.addEventListener('ready.flickity', function () {
      tSliders1.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders1.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders1.resize();
    }, 250));

    var tSliders2 = new Flickity(thumbnailSliders2, {
      asNavFor: ".thumbs-2",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders2.addEventListener('ready.flickity', function () {
      tSliders2.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders2.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders2.resize();
    }, 250));

    var tSliders3 = new Flickity(thumbnailSliders3, {
      asNavFor: ".thumbs-3",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders3.addEventListener('ready.flickity', function () {
      tSliders3.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders3.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders3.resize();
    }, 250));

    var tSliders4 = new Flickity(thumbnailSliders4, {
      asNavFor: ".thumbs-4",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders4.addEventListener('ready.flickity', function () {
      tSliders4.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders4.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders4.resize();
    }, 250));

    var tSliders5 = new Flickity(thumbnailSliders5, {
      asNavFor: ".thumbs-5",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders5.addEventListener('ready.flickity', function () {
      tSliders5.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders5.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders5.resize();
    }, 250));

    var tSliders6 = new Flickity(thumbnailSliders6, {
      asNavFor: ".thumbs-6",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders6.addEventListener('ready.flickity', function () {
      tSliders6.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders6.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders6.resize();
    }, 250));

    var tSliders7 = new Flickity(thumbnailSliders7, {
      asNavFor: ".thumbs-7",
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false, // No page dots for thumbnails
      prevNextButtons: false, // Optional: Hide prev/next buttons for thumbnails
      imagesLoaded: true
    });

    // Resize after images are loaded
    thumbnailSliders7.addEventListener('ready.flickity', function () {
      tSliders7.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      tSliders7.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      tSliders7.resize();
    }, 250));

  } else {
    var flkty = new Flickity(elem, {
      // options
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false
    });

    flkty.on('change', function (index) {
      const mainImage = document.getElementById('main-image');
      if (!mainImage) return;

      mainImage.classList.forEach(cls => {
        if (/^slide-position-\d+$/.test(cls)) {
          mainImage.classList.remove(cls);
        }
      });

      mainImage.classList.add(`slide-position-${index}`);

      const selectedSlide = flkty.cells[index].element;

      const slideImg = selectedSlide.querySelector('img') ||
        (selectedSlide.tagName === 'IMG' ? selectedSlide : null);

      if (!slideImg || mainImage.tagName !== 'IMG') return;

      const newSrc = slideImg.dataset.full || slideImg.src || slideImg.currentSrc;
      mainImage.src = newSrc;
    });

    // Resize after images are loaded
    window.addEventListener('ready.flickity', function () {
      tSliders7.resize();
    });

    // Additional resize with delay to ensure proper initial display
    setTimeout(function () {
      flkty.resize();
    }, 100);

    // Resize on window resize with debounce
    window.addEventListener('resize', debounce(function () {
      flkty.resize();
    }, 500));
  }

  if (document.querySelector(".template-product-pdp-landing")) {

    flkty.on('change', function (index) {
      var selectedSlide = flkty.cells[index].element;
      var sliderVariantValue = selectedSlide.getAttribute('data-variant-value');

      var labels = document.querySelectorAll('variant-radios label');

      labels.forEach((label) => {
        var variantName = label.getAttribute('data-variant-name');

        if (sliderVariantValue === variantName) {
          label.click();
        }
      });
    });

  } else if (document.querySelector(".color-box-imagetest")) {
    var labels = document.querySelectorAll('variant-radios label');
  } else {

    // var labels = document.querySelectorAll('variant-radios label');

    // flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
    //   if ( typeof cellIndex == 'number' ) {
    //     flkty.selectCell( cellIndex );

    //     var mainImage = document.getElementById("main-image");
    //     var newSrc = cellElement.querySelector('.thumb-cell').getAttribute("data-src");
    //     var sliderVariants = document.querySelectorAll('#thumbs .thumb');
    //     // var labels = document.querySelectorAll('variant-radios label');
    //     var sliderVariantValue = cellElement.getAttribute('data-variant-value');

    //     mainImage.src = newSrc;

    //     labels.forEach((label) => {
    //         var variantName = label.getAttribute('data-variant-name');

    //         if (sliderVariantValue === variantName) {
    //           label.click();
    //         }
    //     });
    //   }
    // });

    // NEW AB part for Image Gallery
    var labels = document.querySelectorAll('variant-radios label');

    // flkty.on('staticClick', function(event, pointer, cellElement, cellIndex) {
    //   if (typeof cellIndex == 'number') {
    //   flkty.selectCell(cellIndex);

    //   // Handle first slider (original)
    //       var mainImage = document.getElementById("main-image");
    //       var newSrc = cellElement.querySelector('.thumb-cell').getAttribute("data-src");
    //       var sliderVariants = document.querySelectorAll('#thumbs .thumb');
    //       var sliderVariantValue = cellElement.getAttribute('data-variant-value');

    //       mainImage.src = newSrc;

    //       labels.forEach((label) => {
    //         var variantName = label.getAttribute('data-variant-name');
    //         if (sliderVariantValue === variantName) {
    //           label.click();
    //         }
    //       });
    //     }
    //   });

    // flkty2.on('staticClick', function(event, pointer, cellElement, cellIndex) {
    // if (typeof cellIndex == 'number') {
    // flkty2.selectCell(cellIndex);

    //     // Handle second slider (new)
    //     var mainImageAB = document.getElementById("main-image-ab");
    //     var newSrcAB = cellElement.querySelector('.thumb-cell').getAttribute("data-src");
    //     var sliderVariantsAB = document.querySelectorAll('#thumbs-ab .thumb');
    //     var sliderVariantValueAB = cellElement.getAttribute('data-variant-value');

    //     mainImageAB.src = newSrcAB;

    //     labels.forEach((label) => {
    //       var variantName = label.getAttribute('data-variant-name');
    //       if (sliderVariantValueAB === variantName) {
    //         label.click();
    //       }
    //     });
    //   }
    // });


    // AB part for Image Gallery 
    flkty.on('staticClick', function (event, pointer, cellElement, cellIndex) {
      if (typeof cellIndex == 'number') {
        flkty.selectCell(cellIndex);

        // Elements for image and video
        var mainImageAB = document.getElementById("main-image");
        var mainVideoAB = document.getElementById("main-video");
        var sliderVariantsAB = document.querySelectorAll('#thumbs .thumb');
        var sliderVariantValueAB = cellElement.getAttribute('data-variant-value');

        // Check if the clicked element has data-video-thumb
        if (cellElement.hasAttribute('data-video-thumb') && mainVideoAB) {
          // Handle video thumbnail
          var newSrcAB = cellElement.querySelector('.thumb-cell').getAttribute('data-src');
          mainVideoAB.src = newSrcAB;
          mainVideoAB.style.display = 'block'; // Show video
          mainImageAB.style.display = 'none'; // Hide image
        } else {
          // Handle image thumbnail
          var newSrcAB = cellElement.querySelector('.thumb-cell').getAttribute('data-src');
          mainImageAB.src = newSrcAB;

          if (mainVideoAB) {
            mainImageAB.style.display = 'block'; // Show image
            mainVideoAB.style.display = 'none'; // Hide video
          }
        }

        // Trigger click on matching variant label
        labels.forEach((label) => {
          var variantName = label.getAttribute('data-variant-name');
          if (sliderVariantValueAB === variantName) {
            label.click();
          }
        });
      }
    });

  }
}


if (document.querySelector(".template-product-pdp-touch") || document.querySelector(".color-box-imagetest")) {

  // var elems = document.querySelectorAll('.thumbs');

  // elems.forEach(function(elem) {
  //   var flkty = new Flickity(elem, {
  //     // options
  //     cellAlign: 'center',
  //     contain: true,
  //     draggable: true,
  //     pageDots: true,
  //     prevNextButtons: true,
  //     imagesLoaded: true
  //   });

  //   flkty.resize();
  // });

  document.addEventListener('DOMContentLoaded', () => {

    function waitRecharge(selector, callback) {
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);
        if (element) {
          callback(element);
          observer.disconnect();
        }
      });

      observer.observe(document, {
        childList: true,
        subtree: true,
      });
    }

    waitRecharge('.rc-widget', (element) => {
      var productId = document.querySelector(".variant-chosen").value.toString();
      var matchingLabel = document.querySelector(`label[data-var-id="${productId}"]`);



      if (matchingLabel.classList.contains('option-unavailable')) {
        document.querySelector('.frequency__label').style.display = 'none';
        document.querySelector('product-form').style.display = 'none';
        document.querySelector('.buy-buttons-wrap').style.setProperty('display', 'none', 'important');
        document.querySelector('[id*="loop_subscriptions_loop_widget"]').style.setProperty('display', 'none', 'important');

        if (document.querySelector(".template-product-pdp-touch")) {
          document.querySelector('.klaviyo-form-SschYd').style.display = 'block';
        }
      }
    });

    var labels = document.querySelectorAll("variant-radios label");
    var frequencies = document.querySelectorAll(
      ".rc_select__frequency .shipping_frequency",
    );

    var atcButton = document.querySelector(".product-form__submit");
    var frequencyInterval = document.querySelector(".shipping_frequency");

    function waitForStay(selector, callback) {
      const observer = new MutationObserver(() => {
        const element = document.querySelector(selector);

        if (element) {
          callback(element);

          observer.disconnect();
        }
      });

      observer.observe(document, {
        childList: true,

        subtree: true,
      });
    }

    waitForStay(".loop-widget-purchase-options-container", (element) => {

      var productId = document.querySelector(".variant-chosen").value.toString();
      var matchingLabel = document.querySelector(`label[data-var-id="${productId}"]`);

      if (matchingLabel.classList.contains('option-unavailable')) {
        document.querySelector('.frequency__label').style.display = 'none';
        document.querySelector('product-form').style.display = 'none';
        document.querySelector('.buy-buttons-wrap').style.setProperty('display', 'none', 'important');
        document.querySelector('[id*="loop_subscriptions_loop_widget"]').style.setProperty('display', 'none', 'important');

        if (document.querySelector(".template-product-pdp-touch")) {
          document.querySelector('.klaviyo-form-SschYd').style.display = 'block';
        }
      }

      if (matchingLabel.classList.contains('option-limited')) {
        if (document.querySelector(".template-product-pdp-touch") && document.querySelector(".stock-warning") ) {
          document.querySelector('.stock-warning').style.display = 'block';
        }
      }

      console.log('matchingLabel',matchingLabel);

      var typeLabels = document.querySelectorAll(
        ".loop-widget-container .loop-widget-purchase-option",
      );

      var oneTimePriceContentLoad = document.querySelector(
        "div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price",
      ).textContent;

      document.querySelector(".product-form__submit .price.regular").innerHTML = landingBuyboxQuantityPrice(oneTimePriceContentLoad);

      typeLabels.forEach((label) => {
        label.addEventListener("click", (e) => {
          //console.log(e, "clicked");

          var activeType = document.querySelector(
            ".loop-widget-purchase-option.loop-widget-purchase-option-selected",
          );

          var oneTimeOption = document.querySelector(
            "div[data-loop-widget-onetime-purchase-option]",
          );

          var membershipOption = document.querySelector(
            "div[data-loop-widget-selling-plan-group]",
          );

          //var membershipLowPrice = document.querySelector('.product-form__buttons .ALAmembership');

          //var onetimeLowPrice = document.querySelector('.product-form__buttons .ALAonetime');

          //var membershipBanner = document.querySelector('.AsLowAs-Image .ALAmembership');

          //var onetimeBanner = document.querySelector('.AsLowAs-Image .ALAonetime');

          var membershipPrice = document.querySelector(
            ".product-form__submit .price.membership",
          );

          var oneTimePriceContent = document.querySelector(
            "div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price",
          ).textContent;

          // console.log(oneTimePriceContent, "oneTimePriceContent");

          oneTimePriceContent = oneTimePriceContent.replace(/EUR|GBP|USD|AED/g, "");

          var membershipPriceContent = document.querySelector(
            "div[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price",
          ).textContent;

          // console.log(membershipPriceContent, "membershipPriceContent");

          membershipPriceContent = membershipPriceContent.replace(
            /EUR|GBP|USD|AED/g,
            "",
          );

          var onetimePrice = document.querySelector(
            ".product-form__submit .price.regular",
          );

          var afterpayBlock = document.querySelector("afterpay-placement");

          if (activeType) {
            activeType.classList.remove("active");
          }

          label.classList.add("active");

          // console.log(
          //   label.getAttribute("data-loop-widget-selling-plan-group"),
          //   "label.getAttribute('data-loop-widget-selling-plan-group')",
          // );

          // console.log(
          //   label.getAttribute("data-loop-widget-onetime-purchase-option"),
          //   "label.getAttribute('data-loop-widget-onetime-purchase-option')",
          // );

          if (label.getAttribute("data-loop-widget-selling-plan-group") !== null) {
            membershipPrice.innerHTML =
              membershipPriceContent +
              `<span class="compare-at">` +
              oneTimePriceContent +
              `</span>`;

            membershipPrice.style.display = "flex";

            //membershipLowPrice.style.display = 'inline-block';

            //membershipBanner.style.display = 'block';

            onetimePrice.style.display = "none";

            //onetimeLowPrice.style.display = 'none';

            //onetimeBanner.style.display = 'none';

            atcButton.classList.add("membership-active");

            if (afterpayBlock) {
              afterpayBlock.style.display = "none";
            }
          } else if (
            label.getAttribute("data-loop-widget-onetime-purchase-option") !== null
          ) {
            document.querySelector(
              ".product-form__submit .price.regular",
            ).innerHTML = landingBuyboxQuantityPrice(oneTimePriceContentLoad);

            membershipPrice.style.display = "none";

            //membershipLowPrice.style.display = 'none';

            //membershipBanner.style.display = 'none';

            onetimePrice.style.display = "inline-block";

            //onetimeLowPrice.style.display = 'inline-block';

            //onetimeBanner.style.display = 'block';

            atcButton.classList.remove("membership-active");

            document
              .querySelectorAll(".rc_select__frequency .input-field input")
              .forEach((frequencyInput) => {
                frequencyInput.setAttribute("name", "");
              });

            if (afterpayBlock) {
              afterpayBlock.style.display = "block";
            }
          }
        });
      });

      // Add a MutationObserver to observe changes to the widget container

      const widgetContainerObserver = new MutationObserver(() => {
        // Re-run the code when the widget container is modified

        typeLabels = document.querySelectorAll(
          ".loop-widget-container .loop-widget-purchase-option",
        );

        console.log(typeLabels, "typeLabels");

        // ... (rest of the code remains the same)
      });

      widgetContainerObserver.observe(element, {
        childList: true,

        subtree: true,
      });
      
    });

    frequencies.forEach((frequency) => {
      frequency.addEventListener("click", function () {
        // Update the value of frequencyInterval

        frequencyInterval = this.getAttribute("data-interval");

        var inputId = frequency.getAttribute("for");

        if (inputId) {
          // Find the associated input element using the input ID

          var input = document.getElementById(inputId);

          if (input) {
            document
              .querySelectorAll(".rc_select__frequency .input-field input")
              .forEach((frequencyInput) => {
                //frequencyInput.setAttribute('name', 'properties[_shipping_interval_frequency]');

                frequencyInput.setAttribute("name", "");

                frequencyInput.checked = false;
              });

            // Set the 'name' attribute on the input element

            input.setAttribute("name", "properties[shipping_interval_frequency]");

            input.checked = false;
          }
        }
      });
    });

    labels.forEach((label) => {
      label.addEventListener('click', function () {
        var subsVariantId = this.getAttribute('data-subs-var-id');
        var variantName = this.getAttribute('data-variant-name');
        var upgradeId = this.getAttribute('data-upgrade');
        var sliders = document.querySelectorAll('.thumbs');
        var sliderThumbnails = document.querySelectorAll('.thumbnails');
        //var btnUpgrade = document.querySelector('.btn-upgrade');
        if (document.querySelector(".template-product-pdp-touch")) {
          var selectedColorElement = document.getElementById('selected-color');
        }

        // Remove 'active' class from all labels
        labels.forEach((previousLabel) => {
          previousLabel.classList.remove('active');
        });

        sliders.forEach((slider) => {
          var sliderValue = slider.getAttribute('data-variant-slider');

          if (sliderValue === variantName) {
            slider.style.display = 'block';
            // Get the Flickity instance
            var flkty = Flickity.data(slider);
            // Resize the Flickity slider
            flkty.resize();
          } else {
            slider.style.display = 'none';
          }
        });

        sliderThumbnails.forEach((sliderThumbnail) => {
          var sliderThumbValue = sliderThumbnail.getAttribute('data-variant-slider');

          if (sliderThumbValue === variantName) {
            sliderThumbnail.style.display = 'block';
            if (document.querySelector(".color-box-imagetest")) {
              sliderThumbnail.style.opacity = 1;
            }
            // Get the Flickity instance
            var flktyThumbnails = Flickity.data(sliderThumbnail);
            // Resize the Flickity slider
            flktyThumbnails.resize();
          } else {
            sliderThumbnail.style.display = 'none';
            if (document.querySelector(".color-box-imagetest")) {
              sliderThumbnail.style.opacity = 0;
            }
          }
        });

        // Add 'active' class to the clicked label
        this.classList.add('active');

        if (this.classList.contains('option-unavailable')) {
          document.querySelector('product-form').style.display = 'none';
          document.querySelector('.frequency__label').style.display = 'none';
          document.querySelector('.buy-buttons-wrap').style.setProperty('display', 'none', 'important');
          document.querySelector('[id*="loop_subscriptions_loop_widget"]').style.setProperty('display', 'none', 'important');

          if (document.querySelector(".template-product-pdp-touch")) {
            document.querySelector('.klaviyo-form-SschYd').style.display = 'block';
          }
        } else {
          document.querySelector('product-form').style.display = 'block';
          document.querySelector('.frequency__label').style.display = 'flex';
          document.querySelector('.buy-buttons-wrap').style.setProperty('display', 'block', 'important');
          document.querySelector('[id*="loop_subscriptions_loop_widget"]').style.setProperty('display', 'block', 'important');

          if (document.querySelector(".template-product-pdp-touch")) {
            document.querySelector('.klaviyo-form-SschYd').style.display = 'none';
          }

          document.querySelector('.product-form__submit-text').textContent = 'Buy Now';
        }

        if (this.classList.contains('option-limited')) { 
          if (document.querySelector(".template-product-pdp-touch") && document.querySelector(".stock-warning")) { 
            document.querySelector('.stock-warning').style.display = 'block'; 
          } 
        } else {
          if (document.querySelector(".template-product-pdp-touch") && document.querySelector(".stock-warning")) { 
            document.querySelector('.stock-warning').style.display = 'none'; 
          } 
        }

        // Update #selected-color element with variantName
        if (document.querySelector(".template-product-pdp-touch")) {
          selectedColorElement.textContent = variantName;
        }

        //btnUpgrade.setAttribute('data-upgrade-id', upgradeId);
        if (document.querySelector(".template-product-pdp-touch")) {
          atcButton.setAttribute('data-subs-id', subsVariantId);
        }
      });
    });


  });
}

document.addEventListener('DOMContentLoaded', function () {
  const klaviyoForm = document.querySelector('.klaviyo-form-YcjfE3');

  if (klaviyoForm) {
    const button = klaviyoForm.querySelector('button, [type="submit"], .klaviyo-submit-button');
    if (button) {
      button.addEventListener('click', function (event) {
        const emailInput = klaviyoForm.querySelector('input[name="email"]');
        const emailValue = emailInput ? emailInput.value.trim() : '';
        window.Northbeam.fireEmailCaptureEvent(emailValue, 'Stay In Touch Footer Form');
        console.log('Northbeam fired with email:', emailValue);
        console.log('northbeam success 1');
      }, true);
    }
  } else {
    const observer = new MutationObserver(function (mutations) {
      const form = document.querySelector('.klaviyo-form-YcjfE3');
      if (form) {
        const button = form.querySelector('button, [type="submit"], .klaviyo-submit-button');
        if (button) {
          button.addEventListener('click', function (event) {
            const emailInput = form.querySelector('input[name="email"]');
            const emailValue = emailInput ? emailInput.value.trim() : '';
            window.Northbeam.fireEmailCaptureEvent(emailValue, 'Stay In Touch Footer Form');
            console.log('Northbeam fired with email:', emailValue);
            console.log('northbeam success 2');
          }, true);
          observer.disconnect();
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});



window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'submit') {
    const klaviyoForm = document.querySelector('.klaviyo-form-YcjfE3');
    const emailInput = klaviyoForm.querySelector('input[name="email"]');
    const emailValue = emailInput.value;
    window.Northbeam.fireEmailCaptureEvent(emailValue, 'Sign Up Form Submitted');
  }
});

//new-ab-banner section
// document.addEventListener('DOMContentLoaded', function () {
//   console.log('banner flckty start');
//   const abSliderWrap = document.querySelector('.new-banner-slider');
//   if (abSliderWrap) {
//     console.log('banner flckty step 2');
//     if (abSliderWrap.flickity) {
//       console.log("abSliderWrap.flickity-abSliderWrap.flickity-abSliderWrap.flickity");
//       abSliderWrap.flickity.destroy();
//     }

//     function initializeFlickity() {
//       const abSlider = new Flickity(abSliderWrap, {
//         cellAlign: 'left',
//         contain: true,
//         pageDots: false,
//         freeScroll: true,
//         wrapAround: true,
//         prevNextButtons: true,
//         autoPlay: 3000,
//         adaptiveHeight: true,
//         imagesLoaded: true // Wait for images to load
//       });

//       const carouselStatus = document.querySelector('.new-banner-section .carousel-status');
//       function updateStatus() {
//         if (carouselStatus) {
//           const slideNumber = abSlider.selectedIndex + 1;
//           carouselStatus.textContent = `${slideNumber}/${abSlider.cells.length}`;
//         }
//       }

//       updateStatus();
//       abSlider.on('change', updateStatus);
//       abSlider.resize();
//       setTimeout(() => abSlider.resize(), 200); // Force resize after slight delay
//       console.log('Flickity initialized');
//     }

//     // Wait for images or content to load
//     const images = abSliderWrap.querySelectorAll('img');
//     if (images.length > 0) {
//       let loadedImages = 0;
//       images.forEach(img => {
//         if (img.complete) {
//           loadedImages++;
//           if (loadedImages === images.length) {
//             initializeFlickity();
//           }
//         } else {
//           img.addEventListener('load', () => {
//             loadedImages++;
//             if (loadedImages === images.length) {
//               initializeFlickity();
//             }
//           });
//         }
//       });
//     } else {
//       initializeFlickity(); // No images, initialize immediately
//     }

//     // Prevent form submission on Enter key for carousel-status
//     const carouselStatus = document.querySelector('.new-banner-section .carousel-status');
//     if (carouselStatus) {
//       carouselStatus.addEventListener('keydown', function (e) {
//         if (e.key === 'Enter') {
//           e.preventDefault();
//         }
//       });
//     }
//   } else {
//     console.warn('Slider wrapper (.new-banner-slider) not found');
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  const popupWrapColorbox = document.querySelector('.popup-wrap');

  if (popupWrapColorbox) {
    const seeMore = popupWrapColorbox.querySelector('.see-more');


    const galleryPopup = popupWrapColorbox.querySelector('.gallery-popup');
    const closeGallery = popupWrapColorbox.querySelector('.close-gallery');
    const prevBtn = popupWrapColorbox.querySelector('.prev');
    const nextBtn = popupWrapColorbox.querySelector('.next');
    let currentImage = 0;
    const images = popupWrapColorbox.querySelectorAll('.gallery-images img');

    if (seeMore) {
      seeMore.addEventListener('click', (e) => {
        e.preventDefault();
        popupWrapColorbox.classList.add('gallery-active');
        galleryPopup.style.display = 'flex';
      });

      closeGallery.addEventListener('click', () => {
        popupWrapColorbox.classList.remove('gallery-active');
        galleryPopup.style.display = 'none';
      });

      prevBtn.addEventListener('click', () => {
        images[currentImage].style.display = 'none';
        currentImage = (currentImage - 1 + images.length) % images.length;
        images[currentImage].style.display = 'block';
      });

      nextBtn.addEventListener('click', () => {
        images[currentImage].style.display = 'none';
        currentImage = (currentImage + 1) % images.length;
        images[currentImage].style.display = 'block';
      });
    }
  }
});


(function () {
  'use strict';

  let currentSlide = 0;

  function initGallerySlider() {
    const womensPopup = document.querySelector('.womens-popup');
    if (!womensPopup) {
      return;
    }

    const seeMoreLinks = document.querySelectorAll('.see-more');
    const gallerySlider = document.querySelector('.gallery-slider');
    const galleryBack = document.querySelector('.gallery-back');
    const popupContent = document.querySelector('.popup-content');
    const prevBtn = document.querySelector('.gallery-prev');
    const nextBtn = document.querySelector('.gallery-next');
    const track = document.querySelector('.gallery-track');
    const slides = document.querySelectorAll('.gallery-slide');
    const galleryContainer = document.querySelector('.gallery-container');

    if (!gallerySlider || !popupContent || !track || slides.length === 0) return;

    const totalSlides = slides.length;

    slides.forEach(slide => {
      slide.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    seeMoreLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        popupContent.style.display = 'none';
        gallerySlider.style.display = 'flex';
        currentSlide = 0;
        requestAnimationFrame(() => {
          updateSlider();
        });
      });
    });

    if (galleryBack) {
      galleryBack.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        gallerySlider.style.display = 'none';
        popupContent.style.display = 'flex';
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (currentSlide > 0) {
          currentSlide--;
          updateSlider();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const maxSlide = getMaxSlide();
        if (currentSlide < maxSlide) {
          currentSlide++;
          updateSlider();
        }
      });
    }

    // Swipe Functionality
    let touchStartX = 0;
    let touchStartY = 0;
    let isDragging = false;
    let isScrolling = null; // Track scrolling intent (null, true=vertical, false=horizontal)
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID;

    // Use passive: false to allow preventDefault for blocking scroll
    track.addEventListener('touchstart', touchStart, { passive: false });
    track.addEventListener('touchend', touchEnd);
    track.addEventListener('touchmove', touchMove, { passive: false });

    track.addEventListener('contextmenu', e => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    function touchStart(event) {
      isDragging = true;
      isScrolling = null; // Reset scrolling state
      touchStartX = getPositionX(event);
      touchStartY = getPositionY(event);
      startPos = touchStartX;
      animationID = requestAnimationFrame(animation);

      track.style.transition = 'none';
    }

    function touchEnd() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      track.style.transition = 'transform 0.3s ease';

      const movedBy = currentTranslate - prevTranslate;

      // Threshold to change slide
      const threshold = 50;

      if (movedBy < -threshold) {
        // Swiped Left -> Next Slide
        if (currentSlide < getMaxSlide()) currentSlide += 1;
      } else if (movedBy > threshold) {
        // Swiped Right -> Prev Slide
        if (currentSlide > 0) currentSlide -= 1;
      }

      updateSlider();
    }

    function touchMove(event) {
      if (!isDragging) return;

      const currentPositionX = getPositionX(event);
      const currentPositionY = getPositionY(event);

      // Determine scroll direction on first move if not set
      if (isScrolling === null) {
        const diffX = Math.abs(currentPositionX - touchStartX);
        const diffY = Math.abs(currentPositionY - touchStartY);

        if (diffY > diffX) {
          isScrolling = true; // Vertical scroll
          isDragging = false; // Stop slider drag
          cancelAnimationFrame(animationID);
          return;
        } else {
          isScrolling = false; // Horizontal swipe
          event.preventDefault(); // Lock browser scroll
        }
      } else if (isScrolling) {
        // If confirmed scrolling vertically, do nothing
        return;
      } else {
        event.preventDefault(); // Continue locking browser scroll
      }

      const currentDiff = currentPositionX - startPos;
      currentTranslate = prevTranslate + currentDiff;
    }

    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function getPositionY(event) {
      return event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;
    }

    function animation() {
      if (isDragging && isScrolling === false) {
        setSliderPosition();
        requestAnimationFrame(animation);
      }
    }

    function setSliderPosition() {
      track.style.transform = `translateX(${currentTranslate}px)`;
    }

    function getMaxSlide() {
      const slide = slides[0];
      const slideWidth = slide.getBoundingClientRect().width;
      const containerWidth = galleryContainer.getBoundingClientRect().width;

      const trackStyle = window.getComputedStyle(track);
      let gap = parseFloat(trackStyle.gap);
      if (isNaN(gap)) gap = 0;

      if (window.innerWidth >= 950 && gap === 0) gap = 20;

      const totalSlideWidth = slideWidth + gap;

      const visibleSlides = Math.floor(containerWidth / totalSlideWidth);

      if (containerWidth >= (totalSlides * totalSlideWidth) - gap) {
        return 0;
      }

      let effectiveVisible = containerWidth / totalSlideWidth;
      let max = totalSlides - Math.floor(effectiveVisible);

      if (max < 0) max = 0;

      return max;
    }

    function updateSlider() {
      const slide = slides[0];
      if (!slide) return;

      const slideWidth = slide.getBoundingClientRect().width;

      const trackStyle = window.getComputedStyle(track);
      let gap = parseFloat(trackStyle.gap);
      if (isNaN(gap)) gap = 0;
      if (window.innerWidth >= 950 && gap === 0) gap = 20;

      const offset = currentSlide * (slideWidth + gap);

      prevTranslate = -offset;
      currentTranslate = -offset;

      if (track) {
        track.style.transform = `translateX(-${offset}px)`;
      }

      const maxSlide = getMaxSlide();

      if (prevBtn) {
        if (currentSlide <= 0) {
          prevBtn.style.opacity = '0.5';
          prevBtn.style.pointerEvents = 'none';
        } else {
          prevBtn.style.opacity = '1';
          prevBtn.style.pointerEvents = 'auto';
        }
      }

      if (nextBtn) {
        if (currentSlide >= maxSlide) {
          nextBtn.style.opacity = '0.5';
          nextBtn.style.pointerEvents = 'none';
        } else {
          nextBtn.style.opacity = '1';
          nextBtn.style.pointerEvents = 'auto';
        }
      }
    }

    window.addEventListener('resize', () => {
      const max = getMaxSlide();
      if (currentSlide > max) currentSlide = max;
      updateSlider();
    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallerySlider);
  } else {
    initGallerySlider();
  }
})();

/*document.addEventListener('DOMContentLoaded', function() {
    const checkoutButtons = document.querySelectorAll('#CartDrawer-Checkout, #checkout');
    
    checkoutButtons.forEach(button => {
        button.addEventListener('click', function() {
            window.checkoutExperiment = 1;
            window._conv_q = window._conv_q || [];
            window._conv_q.push(["executeExperiment", "1004181304"]);
        });
    });
});*/

(function () {
  'use strict';

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        "_convertShowBlock": "false"
      }
    }),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then(cart => {
    console.log("Cart attribute updated successfully", cart.attributes);
  })
  .catch(error => {
    console.error("Failed to update cart attribute:", error);
  });

// ---- Loop Widget: Custom Frequency Dropdown with Most Popular Badge ----
(function() {
  function isCustomFreqPage() {
    return !!document.querySelector('.custom-frequency-section');
  }

  function buildDropdown(nativeSelect) {
    if (nativeSelect._freqBadgeDone) return;
    nativeSelect._freqBadgeDone = true;

    var wrapper = nativeSelect.parentElement;
    if (!wrapper) return;

    var dropdown = document.createElement('div');
    dropdown.className = 'custom-freq-dropdown';

    var selectedEl = document.createElement('div');
    selectedEl.className = 'custom-freq-dropdown__selected';
    var selText = document.createElement('span');
    selText.className = 'custom-freq-dropdown__item-text';
    var initIdx = nativeSelect.selectedIndex >= 0 ? nativeSelect.selectedIndex : 0;
    selText.textContent = nativeSelect.options[initIdx] ? nativeSelect.options[initIdx].text : '';
    selectedEl.appendChild(selText);

    var list = document.createElement('div');
    list.className = 'custom-freq-dropdown__list';

    var items = [];
    Array.from(nativeSelect.options).forEach(function(opt, idx) {
      var item = document.createElement('div');
      item.className = 'custom-freq-dropdown__item';
      item.setAttribute('data-value', opt.value);
      if (idx === initIdx) item.classList.add('is-selected');

      var txt = document.createElement('span');
      txt.className = 'custom-freq-dropdown__item-text';
      txt.textContent = opt.text;
      item.appendChild(txt);

      if (/3\s*month/i.test(opt.text)) {
        var badge = document.createElement('span');
        badge.className = 'freq-most-popular-badge';
        badge.textContent = 'Most Popular';
        item.appendChild(badge);
      }

      item.addEventListener('click', function(e) {
        e.stopPropagation();
        nativeSelect.value = opt.value;
        nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        items.forEach(function(el) { el.classList.remove('is-selected'); });
        item.classList.add('is-selected');
        selText.textContent = opt.text;
        dropdown.classList.remove('is-open');
      });

      items.push(item);
      list.appendChild(item);
    });

    selectedEl.addEventListener('click', function(e) {
      e.stopPropagation();
      dropdown.classList.toggle('is-open');
    });

    document.addEventListener('click', function() {
      dropdown.classList.remove('is-open');
    });

    dropdown.appendChild(selectedEl);
    dropdown.appendChild(list);

    // Visually hide native select; keep it in DOM so Loop/form logic still works
    nativeSelect.style.cssText = 'position:absolute;opacity:0;pointer-events:none;width:1px;height:1px;overflow:hidden;';
    wrapper.insertBefore(dropdown, nativeSelect);
  }

  function tryInit() {
    if (isCustomFreqPage()) return; // product-colorbox handles its own widget

    var sel = document.querySelector('select.loop-widget-sp-selector');
    if (!sel || sel._freqBadgeDone) return;

    if (sel.options.length > 0) {
      buildDropdown(sel);
    } else if (!sel._watchingOpts) {
      sel._watchingOpts = true;
      var optObs = new MutationObserver(function() {
        if (sel.options.length > 0) {
          optObs.disconnect();
          buildDropdown(sel);
        }
      });
      optObs.observe(sel, { childList: true });
    }
  }

  // Keep observing continuously — Loop re-renders the widget on variant change,
  // creating a new select element that needs the custom dropdown rebuilt.
  var domObs = new MutationObserver(function() {
    tryInit();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      tryInit();
      domObs.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    tryInit();
    domObs.observe(document.body, { childList: true, subtree: true });
  }
})();
// ---- End Loop Widget Frequency Dropdown Badge ----
})();